import React from "react";
import InputFieldNoChr from "../../FormFields/InputFieldNoChr";
const MessageA14CHR = (props) => {
  return <InputFieldNoChr {...props} />;
};
export default MessageA14CHR;